module.exports = __webpack_public_path__ + "static/img/Dropbox.b53eaec4.svg";